import { Map } from 'immutable';

import * as types from '../actions/action_types';
import { StoreRecord } from '../records/store_records.js';
import { setValue, setError, setPending } from './helpers.js';

const initialState = Map({
  whitelistData: new StoreRecord(),
});

export default (state = initialState, action) => {
  switch(action.type) {
    case types.WHITELIST_PENDING:
      return setPending(state, ['whitelistData']);

    case types.WHITELIST_LOADED:
      return setValue(state, ['whitelistData'], action.data);

    case types.WHITELIST_ERROR:
      return setError(state, ['whitelistData'], action.errorMessage);
  }
  return state;
};
